import moment from 'moment';

export const INIT_START_DATE = 'Start Date';
export const INIT_END_DATE = 'End Date';

export const getMonths = () => {
  moment.locale('en'); // sets words language (optional if current locale is to be used)
  return moment.monthsShort();
};

export const getMonthNumber = (month: string): number => {
  return new Date(`${month} 01, 2017`).getMonth() + 1;
};

export const formatDateMethod = (month: string, year: number): Date => {
  return new Date(`${month} 01, ${year}`);
};

export const formatDate = (date: string): Date => {
  const [month, year] = date.split(' ');
  return formatDateMethod(month, parseInt(year));
};

export function monthDiff(date1: Date, date2: Date) {
  let months;
  months = (date2.getFullYear() - date1.getFullYear()) * 12;
  months -= date1.getMonth();
  months += date2.getMonth();
  return months < 0 ? 0 : months + 1;
}

export const formatDatetoCheckString = (date: string) => {
  const dateS = date.split(' ');
  const month = getMonthNumber(dateS[0]);
  return month > 9 ? `${dateS[1]}-${month}-01` : `${dateS[1]}-0${month}-01`;
};

export const validateLeftButton = (type: string, startYear: number, endYear: number, minYear: number): boolean => {
  return type === 'left' && startYear > minYear ? true : type === 'right' && endYear > minYear + 1 ? true : false;
};

export const validateRightButton = (type: string, startYear: number, endYear: number, maxYear: number): boolean => {
  return type === 'left' && startYear < maxYear - 1 ? true : type === 'right' && endYear < maxYear ? true : false;
};

const Hover = 'hover:bg-slate-100';
const yearbtnStyle = 'flex justify-center items-center w-8 h-8 rounded-full';

export const getButtonClass = (variant: string, disabledLeft: boolean, disabledRight: boolean) => {
  return variant === 'left'
    ? disabledLeft
      ? `${yearbtnStyle} opacity-60`
      : `${yearbtnStyle} ${Hover}`
    : disabledRight
    ? `${yearbtnStyle} opacity-60`
    : `${yearbtnStyle} ${Hover}`;
};

const monthStyle = 'flex w-8 h-8 rounded-full items-center font-nunitoBold justify-center text-xs';

export const monthBtnStyle = `${monthStyle} hover:bg-connectGray`;

export const monthBtnSelectedStyle = `${monthStyle} bg-navy text-white`;

export const monthButtonDisabledStyle = `${monthStyle} opacity-60`;

export const monthBtnSelectedRangeStyle = `${monthStyle} bg-borderGray hover:bg-connectGray`;
